import { USER_LOAD } from '../constants/';

const initialState = {};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case USER_LOAD:
      return { ...action.payload };
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/utils/store/userReducer.js